import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "../components/button.jsx";
import get from "../functions/get.js";
import post from "../functions/post.js";
import Loading from "../components/loading.jsx";
import EditExercise from "./edit_exercise.jsx";

const CreateExercise = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const [formData, setFormData] = useState({
        name: "",
        difficulty: "",
        category: "Verben"
    });

    const [error, setError] = useState("");
    const [ taskError, setTaskError ] = useState("");
    const [loading, setLoading] = useState(true);

    const [exerciseID, setExerciseID] = useState(null);
    const [ exercise, setExercise ] = useState({
        name: "",
        category: "",
        difficulty: "",
        questions: []
    });

    const [ questionID, setQuestionID ] = useState(null);

    const onRes = (res, data) => {
        setLoading(false);

        if(!res) {
            setError("Server nicht erreichbar!");
            return
        }

        const url = location.pathname.split("/");
        
        const uebung = url.findIndex(s => s === "uebung");
        const id = uebung >= 0 ? url[uebung + 1] : null;
        
        const ID = Number(id);

        const frage = url.findIndex(s => s === "frage");
        const frageID = frage >= 0 ? url[frage + 1] : null;

        if (res.status === 200) {

            const currentExercise = data.filter(e => e.id === ID);

            if (currentExercise.length === 0) {
                if(id) {
                    setError("Diese Übung existiert nicht mehr!");
                    setExerciseID(id);
                } else {
                    setExercise(null);
                    setTaskFinal(false);
                }
            } else {
                setExercise(currentExercise[0]);
                setExerciseID(currentExercise[0].id);

                if(frageID) {
                    setQuestionID(frageID);
                    const id = Number(frageID);
                    const exercise = currentExercise[0].questions[id - 1];

                    let newSentence = exercise.sentence
                    if (Array.isArray(exercise.sentence)) {
                        newSentence = exercise.sentence.join(" ").replace(/\s([.,!?;:])/g, "$1");
                    };

                    setTask({
                        sentence: newSentence,
                        type: exercise.question_type,
                    });
                } else {
                    setQuestionID(null);
                }
            };
        } else {
            if(id) {
                setExerciseID(id);
                setTaskError("Diese Übung existiert nicht mehr!");
            };
        };
    };

    useEffect(() => {

        const url = location.pathname.split("/");

        const uebung = url.findIndex(s => s === "uebung");
        const id = uebung >= 0 ? url[uebung + 1] : null;

        const frage = url.findIndex(s => s === "frage");
        const frageid = frage >= 0 ? url[frage + 1] : null;

        setTask({
            sentence: "",
            type: ""
        });

        if(!frageid) {
            setTaskFinal(false);
        }

        if (!id) {
            setExerciseID(null);
            setLoading(false);
        } else {
            setLoading(true);
            get(`/admin/exercises?id=${id}`, onRes, onRes);
        }

    }, [location.pathname]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        setError("");
    };

    const onFormRes = (res, data) => {

        setLoading(false);

        if(!res) {
            setError("Server nicht erreichbar!");
            return;
        }

        if (res.status === 200) {
            const id = data.exercise.id;

            setExerciseID(id);
            setExercise(data.exercise);

            navigate(`/admin/uebungen/erstellen/uebung/${id}`);
        } else {
            setError(data?.error || "Fehler beim Erstellen der Übung.");
        }

    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.name.trim() || !formData.difficulty.trim()) {
            setError("Name und Schwierigkeit müssen angegeben werden.");
            return;
        }

        setLoading(true);
        setError("");
        post("/create/exercise", formData, onFormRes, onFormRes);
    };

    const [ taskFinal, setTaskFinal ] = useState(false);
    const [task, setTask] = useState({ 
        sentence: "", 
        type: "" 
    });
    const [taskInfo, setTaskInfo] = useState({ 
        sentence: "", 
        question: "" 
    });

    useEffect(() => {
        if (exercise) {
            if (exercise.category === "Nomen") {
                setTask(prev => ({ ...prev, type: "Kasus bestimmen" }));
            } else if (exercise.category === "Verben") {
                setTask(prev => ({ ...prev, type: "Verben finden" }));
            }
        }
    }, [exercise?.category]);

    const handleTaskChange = (field, value) => {
        if (field === "sentence" && value.length > 100) return;

        setTask(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const postQuestion = () => {

        let finalType = task.type;
        if(!finalType) {
            finalType = exercise.category === "Nomen" ? "Kasus bestimmen" : "Verben finden";
        }

        if (!task.sentence.trim()) {
            setError("Der Satz darf nicht leer sein.");
            return;
        }

        setLoading(true);
        setError("");

        const curr_questions = exercise.questions[questionID - 1];

        let body;
        if(curr_questions) {
            body = {
                id: curr_questions.id,
                exercise_id: exerciseID,
                sentence: task.sentence,
                category: exercise.category,
                type: finalType
            };
        } else {
            body = {
                exercise_id: exerciseID,
                sentence: task.sentence,
                category: exercise.category,
                type: finalType
            };
        }
 
        post("/create/question", body, (res, data) => {

            setLoading(false);

            if (res.status === 200) {
                setTaskFinal(true);
                setTaskInfo(data);
            } else {
                setError(data?.error || "Fehler beim Erstellen der Frage.");
            }
        }, (res, data) => {
                setLoading(false);
                setError(data?.error || "Fehler beim Erstellen der Frage.");
        });

    };

    const handleQuestionSuccess = (data) => {

        setTaskFinal(false);
        setExercise(prev => ({
            ...prev,
            questions: data,
        }));
        setTask({
            sentence: "",
            task: "",
        });
        
        const url = location.pathname.split("/");
        const frage = url.findIndex(s => s === "frage"); 
        const frageID = frage >= 0 ? url[frage + 1] : null;
        
        if(frageID) {
            navigate(-1);
        }
        setError("Frage erfolgreich gespeichert!");

    };

    const handleQuestionFail = (data) => {

        setTaskFinal(false);
        setExercise(prev => ({
            ...prev,
            questions: data,
        }));
        setError("Fehler beim Erstellen der Frage!");

    };

    const [ deleteEx, setDeleteEx ] = useState(false);

    const deleteExercise = () => {
        if (!exerciseID) return;

        setLoading(true);
        setError("");

        post(
            "/admin/exercise/delete",
            { exercise_id: exerciseID },
            (res, data) => {
                setLoading(false);

                if (res && res.status === 200) {
                    navigate("/admin/uebungen");
                } else {
                    setError(data?.error || "Fehler beim Löschen der Übung.");
                }
            },
            () => {
                setLoading(false);
                setError("Server nicht erreichbar!");
            }
        );
    };

    const [ largeScreen, setLargeScreen ] = useState(window.innerWidth >= 1100);

    useEffect(() => {

        const handleResize = () => {
            setLargeScreen(window.innerWidth >= 1100);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        }

    }, []);

    const [ allQuestions, setAllQuestions ] = useState(false);

    const handleEdit = (question, index) => {

        setAllQuestions(false);
        setLoading(true);
        navigate(`${location.pathname}/frage/${index + 1}`)

    };

    const handleForward = () => {
        setError("");
        setAllQuestions(true);
        const url = location.pathname.split("/");

        const frage = url.findIndex(s => s === "frage");
        const frageID = frage >= 0 ? url[frage + 1] : null;

        if (frage && frageID) {
            const splitURL = url.slice(0, frage).join("/");
            navigate(splitURL, {replace: true});
        }
    };

    if (loading) {
        return (
            <div style={{height: "calc(100vh - 160px)"}} className="flex-row">
                <Loading />
            </div>
        );
    }

    if (exerciseID) {
        return (
            <div>

                {((!taskError && !taskFinal) || (questionID && !taskFinal)) &&
                    <>
                        <h2>{questionID ? "FRAGE BEARBEITEN" : "ÜBUNG ERSTELLEN"}</h2>

                        <div className="exercise-builder">
                            {!questionID &&
                                <>
                                    <p>Füge deiner Übung bis zu 20 einzelne Aufgaben hinzu! Es ist super einfach: Gib unten einen Satz ein, wähle eine der möglichen Aufgabenstellungen aus und los geht die Magie.</p>

                                    <p>Du hast bereits {exercise?.questions?.length}/20 Aufgaben erstellt! 
                                        {exercise?.questions?.length === 20 ? " Diese Übung ist also bereits vollständig." : " Reichere deine Übung mit weiteren Aufgaben an."}</p>
                                </>
                            }

                            <div className="exercise-elem">
                                <label>Satz: </label>
                                <textarea 
                                value={task.sentence}
                                onChange={(e) => handleTaskChange("sentence", e.target.value)}
                                className="sentence-input" />
                            </div>
                                
                            {exercise.category === "Verben" && (
                                <div className="exercise-elem">
                                    <label>Aufgaben-Typ: </label>
                                    <select 
                                        style={{ marginLeft: 0 }}
                                        value={task.type}
                                        onChange={(e) => handleTaskChange("type", e.target.value)}
                                    >
                                        <option value="Verben finden">Verben finden</option>
                                        <option value="Grundform erkennen">Grundform erkennen</option>
                                    </select>
                                </div>
                            )}

                            {exercise.category === "Nomen" && (
                                <div className="exercise-elem">
                                    <label>Aufgaben-Typ: </label>
                                    <select 
                                        style={{ marginLeft: 0 }}
                                        value={task.type}
                                        onChange={(e) => handleTaskChange("type", e.target.value)}
                                    >
                                        <option value="Kasus bestimmen">Kasus bestimmen</option>
                                        <option value="Subjekt bestimmen">Subjekt bestimmen</option>
                                        <option value="Objekte finden">Objekte finden</option>
                                        <option value="Personen erkennen">Personen erkennen</option>
                                    </select>
                                </div>
                            )} 

                            {exercise?.questions?.length < 20 &&
                                <div style={{ marginTop: "10px" }} onClick={postQuestion}>
                                    <Button
                                        className="button-yellow"
                                        text={questionID ? "Frage bearbeiten" : "Frage hinzufügen"}
                                    />
                                </div>
                            }

                            <div className="flex-row exercise-del">

                                {!allQuestions &&
                                    <div onClick={handleForward}>
                                        <Button
                                            className="button-blue"
                                            text="Alle Fragen"
                                        />
                                    </div>
                                }

                                <div onClick={() => {
                                    setDeleteEx(true);
                                    setAllQuestions(false)
                                }}>
                                    <Button
                                        className="button-blue"
                                        text="Übung Löschen"
                                    />
                                </div>
                            </div>

                            {allQuestions &&
                                <div className={largeScreen ? "all-questions-large" : "all-questions-small confirmation"}>
                                    {Array.isArray(exercise.questions) &&
                                        <>
                                            {exercise?.questions?.map((e, idx) => {

                                                return (
                                                    <div
                                                    key={idx} 
                                                    className="question-item"
                                                    onClick={() => handleEdit(e, idx)}
                                                    >
                                                        <div className="flex-row question-flex">
                                                            <p>Aufgabe: {idx + 1}</p>
                                                            <p>Typ: {e.question_type}</p>
                                                        </div>

                                                        {Array.isArray(e.sentence) &&
                                                            <div className="flex-row question-flex" style={{fontSize: "1rem", marginTop: "-5px"}}>
                                                                <p>Satz: </p>

                                                                <p>{e.sentence.map((e, idx) => {              
                                                                    if(idx < 4) {
                                                                        return (
                                                                            <span key={idx}>{e} </span>
                                                                        );
                                                                    }
                                                                })} {e.sentence.length > 4 ? "..." : ""}</p>
                                                            </div>
                                                        }

                                                        {!Array.isArray(e.sentence) &&
                                                            <div className="flex-row question-flex" style={{fontSize: "1rem", marginTop: "-5px"}}>
                                                                <p>Satz: </p>

                                                                <p>{e.sentence.slice(0, 10)}...</p>
                                                            </div>
                                                        }

                                                        <p style={{
                                                            color: "var(--yellow)",
                                                            fontSize: "1rem",
                                                            marginTop: "5px",
                                                        }}
                                                        className="edit-text"
                                                        >Bearbeiten <span 
                                                        style={{
                                                            display: "inline-block"
                                                        }}
                                                        >{">"}</span></p>

                                                    </div>
                                                )
                                            })}
                                        </>
                                    }

                                    <div className="fixed-button" onClick={() => setAllQuestions(false)}>
                                        <Button
                                            className="button-yellow"
                                            text="Zurück"
                                        />
                                    </div>
                                </div>
                            }

                            {deleteEx &&
                                <div className="confirmation">
                                    <div style={{width: "auto", maxWidth: "80vw"}}>
                                        <p>Möchtest du diese Übung wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.</p>

                                        <div className="flex-row" style={{justifyContent: "flex-start"}}>
                                            <button className="button-yellow" onClick={deleteExercise}>Ja</button>
                                            <button className="button-blue" onClick={() => setDeleteEx(false)}>Nein</button>
                                        </div>
                                        
                                    </div>
                                </div>
                            }

                        </div>
                    </>
                }

                {taskFinal &&
                    <EditExercise info={taskInfo} type={taskInfo.type || "edit"} buttonOne={() => setTaskFinal(false)} onSuccess={handleQuestionSuccess} onFail={handleQuestionFail} />
                }

                {error && (
                    <div className="start-warning">
                        <p style={{marginTop: 0}}>{error}</p>
                    </div>
                )}

                {taskError && (
                    <div className="start-warning">
                        <p style={{marginTop: 0}}>{taskError}</p>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div>
            <h2>ÜBUNG ERSTELLEN</h2>

            <p style={{ marginTop: "20px", marginBottom: "20px" }}>
                Bestimme zuerst das Thema und die Schwierigkeit der Übung, bevor du damit beginnen kannst,
                einzelne Fragen erstellen zu lassen.
            </p>

            <form onSubmit={handleSubmit}>
                <div className="form-elem">
                    <label>Name: </label>
                    <input
                        type="text"
                        name="name"
                        placeholder="Name..."
                        value={formData.name}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-elem">
                    <label>Schwierigkeit: </label>
                    <input
                        type="text"
                        name="difficulty"
                        placeholder="z.B. 1–3"
                        value={formData.difficulty}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-elem">
                    <label>Kategorie: </label>
                    <select
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                    >
                        <option value="Verben">Verben</option>
                        <option value="Nomen">Nomen</option>
                    </select>
                </div>

                {error && (
                    <div className="start-warning">
                        <p style={{marginTop: 0}}>{error}</p>
                    </div>
                )}

                <div style={{ marginTop: "10px" }}>
                    <Button
                        className="button-yellow"
                        text="Erstellen"
                        type="submit"
                    />
                </div>
            </form>
        </div>
    );
};

export default CreateExercise;